export const dbTabs1 = {
  presentation: {
    descriptionTitle: "Descrizione dell'alloggio",
    descriptionSub: "Scegli se la descrizione compare nella pagina di prenotazione diretta di ogni unità.",
    visible: "Visibile",
    hidden: "Nascosta",
    amenitiesTitle: "Servizi inclusi",
    amenitiesSub: "Definisci quali servizi e dotazioni vengono mostrati per ogni unità nel tuo motore di prenotazione.",
    amenitiesCount: "{count} servizio | {count} servizi",
    editAmenitiesTitle: "Modifica servizi",
    edit: "Modifica",
    imagesTitle: "Immagini dell'alloggio",
    imagesSubtitle: "Carica, riordina e imposta l'immagine principale di ogni unità che comparirà nel tuo motore di prenotazione.",
  },
  reservations: {
    updating: "Aggiornamento…",
    engineActive: "Motore attivo",
    engineInactive: "Motore inattivo",
    engineActiveDesc: "Gli ospiti possono prenotare le camere direttamente dal tuo link.",
    engineInactiveDesc: "Le prenotazioni dirette sono disattivate per questo hotel.",
    statusActive: "Attivo",
    statusInactive: "Inattivo",
    roomsAvailable: "Camere disponibili",
    colRoom: "Camera",
    colCap: "Cap.",
    colActive: "Attiva",
    noRooms: "Nessuna camera configurata.",
    hotelLabel: "Hotel",
    unitActive: "Attiva",
    unitInactive: "Inattiva",
    enableNotice: "Attiva le prenotazioni dirette per gestire le camere.",
    toastUpdated: "Aggiornato.",
    toastUpdateError: "Impossibile aggiornare.",
    toastGlobalUpdated: "Stato globale aggiornato.",
  },
  promotions: {
    title: "Promozioni sulla prenotazione diretta",
    subtitle: "Controlla quali sono attive, se possono cumularsi e il loro ordine.",
    loading: "Caricamento promozioni…",
    empty: "Nessuna promozione configurata per questa struttura.",
    dragTitle: "Trascina per riordinare",
    switchTitle: "Attiva sulla prenotazione diretta",
    badgeLabel: "Badge",
    badgePlaceholder: "es. -10% / Offerta",
    stackableLabel: "Cumulabile",
    tip: "Suggerimento: attiva la promozione per applicarla alla prenotazione diretta e usa “Cumulabile” se può combinarsi con altre promozioni.",
    toastLoadError: "Impossibile caricare le promozioni.",
    toastSaved: "Promozioni salvate correttamente.",
    toastSaveError: "Impossibile salvare le promozioni.",
    dateFrom: "Dal {date}",
    dateUntil: "Fino al {date}",
  },
  addons: {
    title: "Occupazione e supplementi",
    hint1: "Un solo aggiustamento per {scope}: riduzione per meno ospiti",
    hintOr: "o",
    hint2: "supplemento per ospite aggiuntivo. Non entrambi.",
    perRoom: "camera",
    perAccommodation: "alloggio",
    loading: "Caricamento configurazione…",
    emptyHotel: "Questo hotel non ha camere configurate.",
    thisAccommodation: "Questo alloggio",
    modeReduction: "Riduzione",
    modeSurcharge: "Supplemento",
    modeNone: "Nessun aggiustamento",
    toastLoadError: "Impossibile caricare la configurazione dell'occupazione.",
    toastSaved: "Occupazione salvata correttamente.",
    toastSaveError: "Impossibile salvare l'occupazione.",
  },
};
